import React,{useState} from 'react'
import { Box, Button, useMediaQuery,Typography } from "@mui/material";
import TextField from '@mui/material/TextField';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_REST_URL;







const Forgotpassword = () => {
  const { control, handleSubmit, formState: { errors } } = useForm({mode: "onTouched"});
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [successMessage, setSuccessMessage] = useState('');
  

    const navigate = useNavigate();
    const handleCancel = () => {
        console.log("Clicking the forget Password");
        // Handle forgot password link click here
        // You can navigate to a reset password page or show a dialog for password reset
        navigate("/signin")
      };

      const onSubmit = async (data) => {
       try{
        const response = await axios.post(`${apiUrl}/CCE/api/v1/userEngine/resetPassword`,data);
        console.log("response",response);
        if(response){
          setSuccessMessage('An email containing a link to reset your password has been sent to your email inbox. Be sure to reset within the next 10 minutes, otherwise the link will expire.');
        }else{
          setSuccessMessage("Not successful in sending email");

        }
        

       }catch(error){
        console.log("Error",)

       }
      };

  return (
    <>
    {isSmallScreen ?(<span>
      <Box sx={styles.formboxres}>
      <Typography sx={{ fontSize: "24px", fontWeight: "bold", margin: "-12px 0px 14px 0px" }}>Forgot Password</Typography>
      <div style={{ fontSize: "15px", textAlign: "left" }}>Please enter the email address associated with your account. If an account exists, a verification code will be sent to your email inbox.</div>
      <Box sx={{ textAlign: "center" }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            component="div"
            sx={{
              '& > :not(style)': { m: 1, width: '35ch', textAlign: "center" },
            }}
            noValidate
            autoComplete="off"
          >
            <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  id="outlined-basic"
                  label="Enter email..."
                  variant="outlined"
                  error={!!errors.email}
                  helperText={errors.email ? errors.email.message : null}
                />
              )}
              rules={{
                required: 'Email is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: 'Invalid email address',
                },
              }}
            />
          </Box>
          <Box sx={{ textAlign: "left" }}>
            <Button onClick={handleCancel} sx={styles.cancelbtn} type="button" variant="outlined">
              Cancel
            </Button>
            <Button sx={styles.verifybtn} type="submit" variant="contained">
              Send Reset Link
            </Button>
          </Box>
          {successMessage && (
                  <div
                    style={{
                      marginTop: "10px",
                      color: successMessage.includes("password")
                        ? "green"
                        : "red",
                    }}
                  >
                    {successMessage}
                  </div>
                )}
        </form>
      </Box>
    </Box></span>):(<span><Box sx={styles.formbox}>
      <Typography sx={{ fontSize: "24px", fontWeight: "bold", margin: "-12px 0px 14px 0px" }}>Forgot Password</Typography>
      <div style={{ fontSize: "15px", textAlign: "left" }}>Please enter the email address associated with your account. If an account exists, a verification code will be sent to your email inbox.</div>
      <Box sx={{ textAlign: "center" }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            component="div"
            sx={{
              '& > :not(style)': { m: 2, width: '45ch', textAlign: "left" },
            }}
            noValidate
            autoComplete="off"
          >
            <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  id="outlined-basic"
                  label="Enter email..."
                  variant="outlined"
                  error={!!errors.email}
                  helperText={errors.email ? errors.email.message : null}
                />
              )}
              rules={{
                required: 'Email is required',
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: 'Invalid email address',
                },
              }}
            />
          </Box>
          <Box sx={{ textAlign: "center" }}>
            <Button onClick={handleCancel} sx={styles.cancelbtn} type="button" variant="outlined">
              Cancel
            </Button>
            <Button sx={styles.verifybtn} type="submit" variant="contained">
              Send Reset Link
            </Button>
          </Box>
          {successMessage && (
                  <div
                    style={{
                      marginTop: "10px",
                      color: successMessage.includes("password")
                        ? "green"
                        : "red",
                    }}
                  >
                    {successMessage}
                  </div>
                )}
        </form>
      </Box>
    </Box></span>)}
    </>
    
  )
}

export default Forgotpassword;

const styles = {
    formbox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "35px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "290px",
      width: "420px",
      backgroundColor: "light gray",
    },
    formboxres: {
      position: "absolute",
      top: "45%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      padding: "35px",
      background: "#FFFFFF",
      borderRadius: "8px",
      textAlign: "center",
      height: "300px",
      width: "300px",
      backgroundColor: "light gray",
    },
    verifybtn: {
        width: "150px",
        height: "40px",
        margin: "0.25em 10px 0px 10px",
        backgroundColor: "#002C51",
        color: "white",
        textTransform: "none",
        "&:hover": {
          background: "#002C51",
        },
    
      },
      cancelbtn: {
        width: "100px",
        height: "40px",
        margin: "0.25em 10px 0px 10px",
        backgroundColor: "white",
        color: "black",
        textTransform: "none",
        "&:hover": {
          background: "white",
        },
    
      }
  };